import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Resources } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class SessionFreezeService {
  private readonly frozenSubject = new BehaviorSubject<boolean>(false);

  readonly isFrozen$: Observable<boolean> = this.frozenSubject.asObservable().pipe(distinctUntilChanged());

  get isFrozen(): boolean {
    return this.frozenSubject.value;
  }

  wasFrozenBeforeReload(): boolean {
    return sessionStorage.getItem(Resources.SessionInactiveKey) === 'true';
  }

  freeze(): void {
    if (this.frozenSubject.value) {
      return;
    }

    sessionStorage.setItem(Resources.SessionInactiveKey, 'true');
    this.frozenSubject.next(true);
  }
}
